import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { BackgroundImage, HTMLParser, Image } from '@gik/ui';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

const blockName = 'signup-callout';

export interface ISignupCalloutProps {
  mdBackgroundImageUrl: string;
  mdDownBackgroundImageUrl: string;
  title: string;
  subtitle: string;
  imageUrl: string;
  imageAlt: string;
  className?: string;
}

export default function SignupCallout({
  mdBackgroundImageUrl,
  mdDownBackgroundImageUrl,
  title,
  subtitle,
  imageUrl,
  imageAlt,
  className,
}: ISignupCalloutProps) {
  const bem = bemBlock(blockName);
  const isMd = useBreakpoint(Breakpoint.MD);

  return (
    <section className={bem(null, null, className)}>
      <BackgroundImage
        className={bem('background-image')}
        src={isMd ? mdBackgroundImageUrl : mdDownBackgroundImageUrl}
      />
      <h1 className={bem('title')}>{title}</h1>
      <p className={bem('subtitle')}>
        <HTMLParser rawHtml={subtitle} />
      </p>

      <Image className={bem('image')} alt={imageAlt} src={imageUrl} />
    </section>
  );
}
